export default {
    methods: {
        parseISODateToDisplay(val) {
            let pieces = (val || '').split('-');

            return pieces.length === 3
                ? this.prefixZero(parseInt(pieces[1]))
                    + '/' + this.prefixZero(parseInt(pieces[2]))
                    + '/' + parseInt(pieces[0])
                : '';
        },
        parseDisplayDateToISO(val) {
            let pieces = (val || '').split('/');

            return pieces.length === 3
                ? parseInt(pieces[2])
                    + '-' + this.prefixZero(parseInt(pieces[1]))
                    + '-' + this.prefixZero(parseInt(pieces[0]))
                : '';
        },
        parseDisplayDateToObject(val) {
            let pieces = (val || '').split('/');

            if (pieces.length == 1) {
                pieces = (val || '').split('-');
            }

            if (parseInt(pieces[0]) > 999) {
                return {
                    month: this.prefixZero(parseInt(pieces[1]) || '0'),
                    date: this.prefixZero(parseInt(pieces[2]) || '0'),
                    year: parseInt(pieces[0]),
                }
            }

            let year = pieces[2]?.length == 2 ? 2000 + parseInt(pieces[2]) : pieces[2];

            return {
                month: this.prefixZero(parseInt(pieces[0]) || '0'),
                date: this.prefixZero(parseInt(pieces[1]) || '0'),
                year: year || null,
            }
        },
        prefixZero(val) {
            return ('00' + (val || '')).slice(-2);
        },
        parseStringDate(val) {
            let pieces = (val || '').split('-');

            return {
                year: parseInt(pieces[0]) || null,
                month: parseInt(pieces[1]) || null,
                date: parseInt(pieces[2]) || null,
            }
        },
        buildStringDate(year, month, date) {
            return ('0000' + (year || '')).slice(-4)
                + '-' + ('00' + (month || '')).slice(-2)
                + '-' + ('00' + (date || '')).slice(-2);
        },
        sanitizeStringDate(val) {
            let obj = this.parseStringDate(val);

            return this.buildStringDate(obj.year, obj.month, obj.date);
        },
        isValidDate(val) {
            let parsed = this.parseStringDate(val);

            return Boolean(parsed.year > 999 && parsed.month && parsed.date);
        },
        isNumber(val) {
            return ! isNaN(val);
        },
    },
}
